import React, {useEffect, useState} from 'react'
import ky from 'ky'
import {useParams} from 'react-router-dom'
import vkontanke from './imgs/vkontakte.svg'
import telegram from './imgs/telegram.svg'

export default function PersonalInfo() {
    const {id} = useParams()
    const [userData, setUserData] = useState()
    const [userPhoto, setUserPhoto] = useState()
    const [loadError, setLoadError] = useState('')
    
    function makeSocialMedia(string) {
        let stringArray = string.split(',')
        return stringArray.map((socialMedia) => {
            return socialMedia.includes('vk') ? <a key={socialMedia} className="mx-5" href={socialMedia}><img src={vkontanke} alt="ВКонтакте"/></a>
                                       : <a key={socialMedia} className="mx-5" href={socialMedia}><img src={telegram} alt="Telegram"/></a>
        })
    }

    useEffect(() => {
        const controller = new AbortController()
        let photoUrl
        const profileId = id === 'about' || !id ? '420061875' : id
        setUserData(undefined)
        setUserPhoto(undefined)
        setLoadError('')
        async function loadProfile() {
            const [info, photo] = await Promise.allSettled([
                ky.get(`/api/getinfo/${profileId}`, {
                    headers: {'content-type': 'application/json'}, signal: controller.signal
                }).json(),
                ky.get(`/api/getinfo/${profileId}`, {
                    headers: {'content-type': 'image/jpeg'}, signal: controller.signal
                }).blob()
            ])
            if (controller.signal.aborted) return
            if (info.status === 'fulfilled') setUserData(info.value)
            if (photo.status === 'fulfilled' && photo.value.type.startsWith('image/')) {
                photoUrl = URL.createObjectURL(photo.value)
                setUserPhoto(photoUrl)
            } else {
                setLoadError('Не удалось загрузить фотографию. Попробуйте обновить страницу позже.')
            }
            if (info.status === 'rejected') {
                setLoadError('Не удалось загрузить информацию. Попробуйте обновить страницу позже.')
            }
        }
        loadProfile()
        return () => {
            controller.abort()
            if (photoUrl) URL.revokeObjectURL(photoUrl)
        }
    }, [id])

    return <>
        <div className='whitespace-pre-wrap w-screen min-h-screen h-full bg-cover bg-main-darkblue flex justify-around items-center'>
            <div className='lg:w-5/6 pt-10 sm:pt-40 sm:pb-40 w-full pb-10 lg:flex items-center'> 
		<div className='mt-40 lg:mt-0 lg:w-1/3 w-5/6 h-3/4 2xl:w-1/4 m-auto p-0'>
                    {userPhoto && <img src={userPhoto} alt="Фотография владельца страницы" />}
                </div>
                <div className='flex flex-col w-5/6 lg:w-3/5 h-3/4 m-auto lg:mt-0 mt-20 text-white'>
                    <div className='text-left'>
                        <h1 className='text-huge lg:text-left text-center text-main-orange'>Обо мне</h1>
                        <p className=' text-white text-small my-8'>{userData ? userData.aboutInfo : null}</p>
                        {loadError && <p role="alert" className="text-white text-small my-4">{loadError}</p>}
                    </div>
                    <div className='text-left'>
                        <h1 className='text-huge lg:text-left text-center text-main-orange'>Связь со мной</h1>
                        <div className=' text-white text-medium my-8 lg:my-6 lg:mx-0 m-auto w-full lg:w-2/5 flex justify-between'>
                            {userData?.socialMedia ? makeSocialMedia(userData.socialMedia) : ''}
                        </div>
                    </div>
                </div>
            </div>

        </div>
    </>
}
